/* eslint-disable */
import React, {Component} from 'react';
import './less/coreBusiness.less';
import {Row, Col, Menu, Icon,} from 'antd';
import {BusinessDataSource} from '../common/globalDataList';

const {SubMenu} = Menu;
export default class coreBusiness extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: "",
            title: "",
            conList: [],
        };
    }

    componentWillMount() {
        let selectedData = BusinessDataSource['大气污染防治"一市一策"'];
        this.setState({selectedData, title: selectedData.title, conList: selectedData.conList});
    }

    componentDidMount() {
        let key = window.location.hash.split("?")[1];
        console.log('key', key);
        switch (key) {
            case 'key=1':
                this.handleClick({key: '气象服务及灾害预报预警'});
                break;
            case 'key=2':
                this.handleClick({key: '空气质量预报预警与应用'});
                break;
            case 'key=3':
                this.handleClick({key: '大气污染源耦合解析'});
                break;

            case 'key=10':
                this.handleClick({key: '大气污染防治"一市一策"'});
                break;
            case 'key=11':
                this.handleClick({key: '大气环境网格化监管与重污染天气应对'});
                break;
            case 'key=12':
                this.handleClick({key: '大气污染源耦合解析'});
                break;
            case 'key=13':
                this.handleClick({key: '水文水质评价分析'});
                break;

            default:
                this.handleClick({key: '大气污染防治"一市一策"'});
                break;
        }

    }

    componentWillReceiveProps(nextProps) {

    }

    renderContent() {
        const {conList,} = this.state;
        return conList && conList.length > 0 && conList.map((con, index) => {
                return (
                    <div className={"conContent"} key={index}>
                        {
                            con && con.pName &&
                            <div className={"pName"}>
                                {con.pName}
                            </div>
                        }
                        {
                            con && con.title &&
                            <p className={"titleP"}>{con.title}</p>
                        }
                        <div>
                            {con.textList && con.textList.length > 0 && con.textList.map((text) => {
                                return (
                                    <p >{text}</p>
                                )
                            })}
                        </div>
                        <div>
                            {con.imgList && con.imgList.length > 0 && con.imgList.map((img) => {
                                return (
                                    <div className={"imgCon"}>
                                        <div className={"imgTitle"}>{img.title}</div>
                                        <img src={img.url}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            });
    }

    handleClick = e => {
        if (e) {
            let selectedData = BusinessDataSource[e.key];
            this.setState({selectedData, title: selectedData.title, conList: selectedData.conList});
        }
    };

    getDefaultKeyValue() {
        let key = window.location.hash.split("?")[1];
        switch (key) {
            case 'key=1':
                return '气象服务及灾害预报预警';
                break;
            case 'key=2':
                return '空气质量预报预警与应用';
                break;
            case 'key=3':
                return '大气污染源耦合解析';
                break;

            case 'key=10':
                return '大气污染防治"一市一策"';
                break;
            case 'key=11':
                return '大气环境网格化监管与重污染天气应对';
                break;
            case 'key=12':
                return '大气污染源耦合解析';
                break;
            case 'key=13':
                return '水文水质评价分析';
                break;
            default:
                return '大气污染防治"一市一策"';
                break;
        }
    }

    render() {
        const {title,} = this.state;
        let defaultKeyValue = this.getDefaultKeyValue();
        return (
            <div className={"coreBusiness"}>
                <Row>
                    <Col span={6}>
                        <Menu
                            onClick={this.handleClick}
                            style={{width: 256,height:700,border:"1px solid #c0c0c0",fontWeight:"800"}}
                            defaultSelectedKeys={[defaultKeyValue]}
                            defaultOpenKeys={[defaultKeyValue]}
                            mode="inline">
                            <Menu.Item key='大气污染防治"一市一策"' style={{marginTop:"30px"}}>大气污染防治"一市一策"技术支持与辅助决策</Menu.Item>
                            <Menu.Item key="大气环境数据分析与应用">大气环境数据分析与应用</Menu.Item>
                            <Menu.Item key="大气污染源耦合解析">大气污染源耦合解析</Menu.Item>
                            <Menu.Item key="大气环境容量测算与达标规划">大气环境容量测算与达标规划</Menu.Item>
                            <Menu.Item key="空气质量预报预警与应用">空气质量预报预警与应用</Menu.Item>
                            <Menu.Item key="大气环境网格化监管与重污染天气应对">大气环境网格化监管与重污染天气应对</Menu.Item>
                            <Menu.Item key="水文水质评价分析">水文水质评价分析</Menu.Item>
                            <Menu.Item key="水质预报预警">水质预报预警</Menu.Item>
                            <Menu.Item key="水污染事故溯源">水污染事故溯源</Menu.Item>
                            <Menu.Item key="危险天气预报预警系统展示">危险天气预报预警系统展示</Menu.Item>
                            <Menu.Item key="生态环境监测评价">生态环境监测评价</Menu.Item>
                            <Menu.Item key="气象服务及灾害预报预警">气象服务及灾害预报预警</Menu.Item>
                        </Menu>
                    </Col>
                    <Col span={18}>
                        <div className={"coreTitle"}>
                            <h1>
                                <p>{title}</p>
                            </h1>
                        </div>
                        {this.renderContent()}
                        <div style={{height: '5vh'}}></div>
                        {/*   <div>
                         产品介绍 / Platform Profile
                         </div>
                         <div>
                         {introduce}
                         </div>
                         <div>
                         技术路线 / Seven Technologies
                         </div>
                         <div>
                         {
                         imgList && imgList.length > 0 && imgList.map((img) => {
                         return (<div></div>)
                         })
                         }
                         </div>
                         <div>
                         服务案例 / Seven Technologies
                         </div>*/}

                    </Col>
                </Row>
            </div>
        )
    }
}

